export const states = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO"
]

const features = [{
    name: 'estacionamento',
    value: false
},{
    name: 'lanchonete',
    value: false
},{
    name: 'restaurante',
    value: false
},{
    name: 'espaço kids',
    value: false
},{
    name: 'estadia',
    value: false
},{
    name: 'pesca esportiva',
    value: false
},{
    name: 'churrasqueira',
    value: false
},{
    name: 'acessibilidade',
    value: false
},{
    name: 'espaço para eventos',
    value: false
},{
    name: 'quiosques',
    value: false
},]

const openingHours = {
    monday : { open : `00:00`, close : `00:00` },
    tuesday : { open : `00:00`, close : `00:00` },
    wednesday : { open : `00:00`, close : `00:00` },
    thursday : { open : `00:00`, close : `00:00` },
    friday : { open : `00:00`, close : `00:00` },
    saturday : { open : `00:00`, close : `00:00` },
    sunday : { open : `00:00`, close : `00:00` },
    holidays : { open : `00:00`, close : `00:00` },
}

const resume = {
    name: '',
    address: {
        street:'',
        streetNumber: '',
        aditionalInformation: '',
        locality: '',
        city: '',
        shortState: 'Estado',
        country: '',
        postalCode: '',
        location: {
            lat:'',
            lng: ''
        }
    },
    thumbnail : '',
    visibility: false,
    owner: false,
    author: '',
    features,
}

const details = {
    focalPerson: '',
    phoneNumber: '',
    mobileNumber:'',
    site: '',
    email: '',
    images: [],
    about:'',
    price: '',
    openingHours
}

export const local = {
    resume,
    details,
    geoOptions: []
}

